import { render, staticRenderFns } from "./StarGraphic.vue?vue&type=template&id=360a5f5f&functional=true&"
import script from "./StarGraphic.vue?vue&type=script&lang=js&"
export * from "./StarGraphic.vue?vue&type=script&lang=js&"
import style0 from "./StarGraphic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports